import React from 'react';
import { ManageAccountLanding } from './manage-account/Landing';
import { QuickServicesLanding } from './quick-services/Landing';
import { GuestPortalTopnav } from './Topnav';
import { AnnouncementBanner } from './AnnouncementBanner';

export const GuestPortalLanding = () => {
  return (
    <div className="h-screen flex flex-col bg-[#f8f9fa] font-sans overflow-hidden">
      <GuestPortalTopnav />
      
      {/* Banner */}
      <AnnouncementBanner />

      {/* Main Content Split */}
      <div className="flex-1 flex flex-col lg:flex-row overflow-hidden">
        <div className="w-full lg:w-1/2 flex-shrink-0 h-full overflow-y-auto">
          <ManageAccountLanding />
        </div>
        <div className="w-full lg:w-1/2 flex-shrink-0 h-full overflow-y-auto">
          <QuickServicesLanding />
        </div>
      </div>
    </div>
  );
};

export default GuestPortalLanding;
